import axios from "axios";
import { createBrowserHistory } from "history";

const api = axios.create({
  baseURL: process.env.REACT_APP_EUREKA_PACS_URL,
});

// ⚡ Crée un objet history pour naviguer depuis un interceptor
const history = createBrowserHistory();

// Ajout d’un intercepteur pour toutes les réponses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Supprimer éventuellement le token
      localStorage.removeItem("token");
      localStorage.removeItem("tenant");

      // Redirection vers la route déconnexion
      history.push("/deconnexion");
      window.location.reload(); // force le re-render
    }
    return Promise.reject(error);
  }
);

export default api;
